import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ProactiveChatActions = createActionGroup({
  source: 'ProactiveChat',
  events: {
    'Show Proactive': emptyProps(),
    'Hide Proactive': emptyProps(),
    'Check Proactive Config': props<{
      proactiveChatConfig: ProactiveChatConfig;
    }>(),
  },
});
